import type { FC } from "react";

interface MetricItem {
	spend: number;
	impressions: number;
	reach: number;
	clicks: number;
	ctr: number;
	cpc: number;
	cpm: number;
	conversions: number;
	costPerResult: number;
}

const fmt = (val: number, decimals = 2) =>
	val.toLocaleString(undefined, {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
	});

export const MetricsColumns: FC<{ item: MetricItem }> = ({ item }) => (
	<>
		<td>${fmt(item.spend)}</td>
		<td>{fmt(item.impressions, 0)}</td>
		<td>{fmt(item.reach, 0)}</td>
		<td>{fmt(item.clicks, 0)}</td>
		<td>{fmt(item.ctr)}%</td>
		<td>${fmt(item.cpc)}</td>
		<td>${fmt(item.cpm)}</td>
		<td>{fmt(item.conversions, 0)}</td>
		<td>${fmt(item.costPerResult)}</td>
	</>
);

export const MetricsHeaders: FC = () => (
	<>
		<th>Spend</th>
		<th>Impr.</th>
		<th>Reach</th>
		<th>Clicks</th>
		<th>CTR</th>
		<th>CPC</th>
		<th>CPM</th>
		<th>Conv.</th>
		<th>Cost/Res.</th>
	</>
);
